import React from 'react';
import phoneImg from '../../assets/images/feature3.webp';
import './realguidancesection.css';

const RealGuidanceSection = () => {
  return (
    <section className="real-guidance-section">
       <div className="real-guidance-container">
      <img
        src={phoneImg}
        alt="MyNaksh Chat UI"
        className="real-guidance-image"
      />
      {/* 📝 Text Content on the Right */}
      <div className="real-guidance-content">
        <p className="real-guidance-title">
          For the Journey Within
        </p>
        <h2 className="real-guidance-heading">
          Your Entire Life, Decoded
        </h2>
        <p className="real-guidance-description">
          Your Life Dashboard analyzes the Shani Gochar (शनि गोचर), Guru Gochar (गुरु गोचर) and all transit effects to help you understand your past and present.
        </p>
      </div>
      </div>
    </section>
  );
};

export default RealGuidanceSection;
